import React, { useEffect, useState } from "react";

export default function NumberDisplay({ first, last, char, isVisible }) {
  const [currentNumber, setCurrentNumber] = useState(first);

  useEffect(() => {
    if (!isVisible) return; 
    setCurrentNumber(first); 
    const interval = setInterval(() => {
      setCurrentNumber((prev) => {
        if (prev < last) {
          return prev + 1;
        } else if (prev > last) {
          return prev - 1;
        } else {
          clearInterval(interval);
          return prev;
        }
      });
    }, 2000 / Math.abs(last - first));

    return () => clearInterval(interval); 
  }, [first, last, isVisible]);

  return (
    <span>
      {currentNumber}
      {char}
    </span>
  );
}
